export default __webpack_public_path__ + "static/media/A28.a6d2513b.png";